import { useLingui } from "@lingui/react/macro";
import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { ChannelTeamForm } from "~/components/views/app/channel/team-form";
import { getRolesOptions } from "~/models/role";
import { useTRPC } from "~/trpc/client";

export const Route = createFileRoute(
	"/_app/podcasts/$channelUid/settings/team",
)({
	component: Page,
	async loader({ context, params }) {
		context.queryClient.prefetchQuery(
			context.trpc.parameter.languages.queryOptions(),
		);
		context.queryClient.prefetchQuery(context.trpc.user.list.queryOptions());
		context.queryClient.prefetchQuery(
			context.trpc.channel.listPermissions.queryOptions({
				channelUid: params.channelUid,
			}),
		);
	},
});

function Page() {
	const { channelUid } = Route.useParams();
	const trpc = useTRPC();
	const { i18n } = useLingui();

	const channelQuery = useSuspenseQuery(
		trpc.channel.find.queryOptions({ channelUid }),
	);
	const { data: users } = useQuery(trpc.user.list.queryOptions());
	const { data: permissions } = useQuery(
		trpc.channel.listPermissions.queryOptions({
			channelUid,
		}),
	);

	return (
		<ChannelTeamForm
			channel={channelQuery.data}
			channelPermissions={permissions}
			users={users}
			roles={getRolesOptions(i18n)}
		/>
	);
}
